import React, { useState, useEffect,useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAction,useQuery } from 'convex/react';
//import { api } from './convex/_generated/api';
//import { useAuth } from './contexts/AuthContext';
import { toast } from 'sonner';
import axios from "axios";
import { api } from './convex/_generated/api';

const PACKS = [
  {
    id: "premium",
    title: "AI Meal Planner Pro",
    price: "$9.99/mo",
    includes: [
      "Unlimited AI meal plans",
      "Smart grocery list generation",
      "Pantry inventory management",
      "Food waste tracking & savings dashboard",
      "Personalized recipe recommendations",
      "Expiry date reminders",
      "Priority support & future premium features"
    ],
    color: "#4CAF50",
    popular: true
  }
];

export default function PricingPageMeals() {
  const [checkoutLoading, setCheckoutLoading] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const sessionId = location.state?.sessionId || localStorage.getItem('session_id');
  
  const [error, setError] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);
  
  const createCheckout = useAction(api.stripe.createCheckoutSessionTravel);
  const createPortal = useAction(api.stripe.createPortalSessionTravel);
  const user = useQuery(api.users.getUserBySession,
    sessionId ? { sessionId } : "skip"
    
  );
  
if (user?.role === 'premium') {
      toast.success("You already have access!");
      localStorage.setItem('session_id', sessionId);
      navigate("/profile", { state: { sessionId } });
      return;
}

  const handleGetPack = async (packId) => {
    localStorage.setItem('session_id', sessionId);
    if (!sessionId) {
      toast.error("Please sign in first");
      navigate("/");
      return;
    }
    
    setCheckoutLoading(packId);
    try {
    
      const { url } = await createCheckout({
        userId: user._id,
        email: user.email,
        packId: packId
      });
      localStorage.setItem('session_id', sessionId);
      window.location.href = url;
    } catch (err) {
      toast.error("Failed to start checkout");
    } finally {
      setCheckoutLoading(null);
    }
  };

  const handleManage = async (packId) => {
  setCheckoutLoading("portal");
  try {
   localStorage.setItem('session_id', sessionId);
   const { url } = await createPortal({ userId: user._id, packId });
   window.location.href = url;
  } catch (err) {
    setError("Failed to open billing portal");
  } finally {
    setCheckoutLoading(null);
  }
};


function userHasPack(user, packId) {
  return packId === "premium" && user?.role === "premium";
}

  return (
    <section style={{ width:"1400px", margin: "0 auto", padding: "48px 24px", background: "#FFF9F2", animation: "fadeUp 0.4s ease both" }}>
      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <h2 style={S.sectionTitle}>High-Stakes Packs</h2>
        <p style={{ color: "#8A7A6C", fontSize: 16 }}>Full playbooks for when it really matters</p>
        <p style={{ color: "#A89684", fontSize: 13, marginTop: 8 }}>All packs included in one Pro subscription — $9/mo</p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))", gap: 20, marginBottom: 32 }}>
        {PACKS.map(pack => (
          <div key={pack.id} style={{
            ...S.packCard,
            borderColor: pack.popular ? pack.color : "#F0E4D6",
            animation: pack.popular ? "glow 3s ease infinite" : "none",
          }}>
            {pack.popular && (
              <div style={{ position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)", fontSize: 11, fontWeight: 700, color: "#fff", padding: "4px 14px", borderRadius: 20, background: pack.color, whiteSpace: "nowrap" }}>
                Most Popular
              </div>
            )}
            <div style={{ fontSize: 22, color: pack.color, marginBottom: 12 }}>✦</div>
            <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 19, fontWeight: 700, color: "#2B2118", marginBottom: 6 }}>
              {pack.title}
            </h3>
            <div style={{ fontSize: 28, fontWeight: 700, fontFamily: "'Playfair Display', serif", color: pack.color, marginBottom: 20 }}>
              {pack.price}
            </div>
            <div style={{ marginBottom: 24 }}>
              {pack.includes.map((item, i) => (
                <div key={i} style={{ fontSize: 13, color: "#8A7A6C", padding: "6px 0", borderBottom: "1px solid #F0E4D6" }}>
                  ✓ {item}
                </div>
              ))}
            </div>
            {userHasPack(user, pack.id) ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <div style={{ fontSize: 12, color: "#3F8F5C", textAlign: "center", padding: "8px", background: "#EAF7EE", borderRadius: 8, border: "1px solid #BFE3CB" }}>
                    ✓ Active
                    </div>
                    <button
                    disabled={true}
                    onClick={() => handleManage(pack.id)}
                    style={{ width: "100%", border: "1px solid #E07A7A", borderRadius: 10, padding: "12px", fontSize: 14, fontWeight: 600, color: "#E07A7A", cursor: "pointer", fontFamily: "'DM Sans', sans-serif", background: "transparent" }}>
                    Cancel Subscription
                    </button>
            </div>
                ) : (
                <button
                    disabled={true}
                    onClick={() => handleGetPack(pack.id)}
                    style={{ width: "100%", border: "none", borderRadius: 10, padding: "12px", fontSize: 14, fontWeight: 600, color: "#fff", cursor: "pointer", fontFamily: "'DM Sans', sans-serif", background: pack.color }}>
                    Get This Pack
                </button>
                )}
          </div>
        ))}
      </div>

    </section>
  );
}

const S = {
  sectionTitle: { fontFamily: "'Playfair Display', serif", fontSize: 34, fontWeight: 700, color: "#2B2118", marginBottom: 10 },
  packCard: { background: "#FFFFFF", border: "1px solid #F0E4D6", borderRadius: 16, padding: "28px 24px", position: "relative", boxShadow: "0 4px 14px rgba(43,33,24,0.05)" },
};
